var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{attrs:{"disabled":true},model:{value:(_vm.params.value),callback:function ($$v) {_vm.$set(_vm.params, "value", $$v)},expression:"params.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }